<template><section><h1>Radio</h1>
<blockquote>
<p>单选框</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>checked</td>
<td style="text-align:left">单选框当前选中的数据，请使用<code>v-model</code>获取及设置</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>value</td>
<td style="text-align:left">单选框值</td>
<td></td>
<td><code>slot内容</code></td>
</tr>
<tr>
<td>size</td>
<td style="text-align:left">单选框尺寸，可选值 <code>sm</code>/<code>md</code>/<code>lg</code></td>
<td><code>String</code></td>
<td><code>md</code></td>
</tr>
<tr>
<td>color</td>
<td style="text-align:left">单选框颜色</td>
<td><code>String</code></td>
<td><code>#f02f45</code></td>
</tr>
<tr>
<td>reselect</td>
<td style="text-align:left">是否可重选</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>disabled</td>
<td style="text-align:left">是否禁用</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Radio.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-11.vue?953c81d6